module.exports = __webpack_public_path__ + "static/media/dialog_btn1.288599e0.svg";